import { PageName } from '@/core/router/routes/constants';
import { RouteRecordRaw } from 'vue-router';

export const GeneralRoutes: RouteRecordRaw[] = [
    {
        component: () => import('@/shared/kitchensink/ui/KitchenSinkPage.vue'),
        name: PageName.KITCHEN_SINK,
        path: '/b2b/kitchensink',
    },
];
